import { RecaptchaResponse } from "@/types/recaptcha";
import {
  AnswerValidityResponse,
  QuestionRecord,
} from "@/types/securitySettings";

import { httpRequest } from "@/lib/http";

export async function fetchAnswerValidity(
  headers: HeadersInit,
  body: string
): Promise<AnswerValidityResponse | RecaptchaResponse> {
  const url = `/account-utilities/api/security/answer`;

  const method = "POST";

  const requestInit: RequestInit = { body, headers, method };

  const answerValidityResponse = (
    await httpRequest<AnswerValidityResponse | RecaptchaResponse>(
      url,
      requestInit
    )
  ).data;

  if (!answerValidityResponse) throw new Error("Empty http response");

  return answerValidityResponse;
}

export async function fetchSecurityQuestions(
  init?: RequestInit
): Promise<QuestionRecord[] | RecaptchaResponse> {
  const url = `/account-utilities/api/security/question`;

  const headers = init?.headers;
  const method = "GET";

  const requestInit: RequestInit = { headers, method };

  const questions = (
    await httpRequest<QuestionRecord[] | RecaptchaResponse>(url, requestInit)
  ).data;

  if (!questions) throw new Error("Empty http response");

  return questions;
}
